import Slider from "./Slider";
export { UnstableContext } from "./context";
export default Slider;